import React, { Fragment, useEffect, useState } from 'react';
import { Box, Chip, Collapse, List, ListItem, Typography, Link } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { OKRButton } from '../../../../Common/OKRButton';
import {
	AlertInfoIcon,
	CollapseAllIcon,
	CopyOkrsIcon,
	DownloadIcon,
	ExpandAllIcon,
} from '../../../../../config/svg/CommonSvg';
import { AddIconBlue, DeleteIcon, EditIcon, PublishedOnIcon } from '../../../../../config/svg/CommonSvgIcon';
import '../../../../../styles/pages/admin/settings/default-okr/default-okr-listing.scss';
import { OrgKpisAssignChip } from './OrgKpisAssignChip';
import { RightArrowIcon } from '../../../../../config/svg/ArrowSvg';
import { CalendarIcon, CloneIcon } from '../../../../../config/svg/CommonSvgIcon';
import { useDispatch, useSelector } from 'react-redux';
import {
	defaultOkrDelete,
	exportDefaultOkrReport,
	getAdminDefaultOkrList,
	getDefaultKpiCategories,
	openAdminCopyOkr,
	publishObjective,
	refreshAdminDefaultOkrList,
	RePublishObjective,
} from '../../../../../action/adminDefaultOkr';
import { getMonthDateYear, getUserDetails } from '../../../../../config/utils';
import { Enums } from '../../../../../config/enums';
import { DialogComponent } from '../../../CommonComponent/DialogComponent';
import { AnimatedIcon } from '../../../../Common/AnimatedIcon';
import AddUserImg from '../../../../../images/copy-import-previous-goal.svg';
import DefaultOkrImg from '../../../../../images/my-goal-bg.svg';
import AlertDialog from '../../../../Common/Dialog';
import { DefaultKpiFilter } from './DefaultKpiFilter';
import noRecordFound from '../../../../../images/search-placeholder.svg';

export const OrganizationKpisList: React.FC<any> = (props: any) => {
	const {
		handleCloneOkr,
		setListLoading,
		listLoading,
		handleEditDefaultOkrClick,
		showApiMsg,
		selectedCycleDetails,
		handleClickDefaultOkr,
		setHighlightDefaultOkr,
		highlightDefaultOkr,
		setShowLoader,
	} = props;
	const { t } = useTranslation();
	const userDetail: any = getUserDetails();
	const dispatch = useDispatch();
	const { refreshDefaultOkr } = useSelector((state: any) => state.adminDefaultOkrReducer);

	const [listingData, setListingData] = useState<any>([]);
	const [alertMessage, setAlertMessage] = useState<any>('');
	const [expandedKrList, setExpandedKrList] = useState<number[]>([]);
	const [modalProps, setModalProps] = useState<any>({ open: false, message: '', details: '' });
	const [modalOpen, setModalOpen] = useState(false);
	const [publishDisabled, setPublishDisabled] = useState(false);
	const [publishButton, setPublishButton] = useState<number>(0);
	const [republishButton, setReublishButton] = useState<number>(0);
	const [modalPerformanceProps, setModalPerformanceProps] = useState<any>({ open: false, message: '', details: '' });
	const [categories, setCategories] = useState<any>([]);
	const defaultSearchFilter: any = {
		kpiCategoryMasterId: [],
		assignType: [],
		status: [],
		designationAssignId: [],
		jobLevelAssignId: [],
		searchText: '',
	};
	const [finalFilterCondition, setFinalFilterCondition] = useState<any>({ ...defaultSearchFilter });
	const [appliedFilter, setAppliedFilter] = useState<boolean>(false);

	useEffect(() => {
		defaultOkrAPICall();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedCycleDetails, finalFilterCondition]);
	useEffect(() => {
		if (refreshDefaultOkr) {
			dispatch(refreshAdminDefaultOkrList(false));
			setFinalFilterCondition({ ...defaultSearchFilter });
			defaultOkrAPICall();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [refreshDefaultOkr]);

	useEffect(() => {
		fetchKpiCategories();
	}, []);

	const defaultOkrAPICall = (showLoading = true) => {
		if (selectedCycleDetails) {
			showLoading && setListLoading(true);
			getPerformanceReviewList({
				cycleId: selectedCycleDetails?.organisationCycleId,
				searchText: finalFilterCondition.searchText,
				kpiCategoryMasterId: finalFilterCondition.kpiCategoryMasterId,
				assignType: finalFilterCondition.assignType,
				status: finalFilterCondition.status,
				designationAssignId: finalFilterCondition.designationAssignId,
				jobLevelAssignId: finalFilterCondition.jobLevelAssignId,
			});
		}
	};

	const fetchKpiCategories = async () => {
		try {
			const response: any = await dispatch(getDefaultKpiCategories());
			if (response) {
				if (response.data && response.data.status === 200) {
					const { entity } = response.data;
					setCategories(entity);
				} else {
					setCategories([]);
				}
			}
		} catch (e) {
			console.error(e);
		}
	};
	const handlePublishOkr = async () => {
		setPublishDisabled(true);
		const response: any = await dispatch(
			publishObjective({
				teamCycleDetailId: selectedCycleDetails?.organisationCycleId,
				objectiveId: 0,
				loginUserId: 0,
			})
		);
		if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
			dispatch(refreshAdminDefaultOkrList(true));
			setPublishDisabled(false);
		} else {
		}
	};
	const handleRePublishOkr = async () => {
		setPublishDisabled(true);
		const response: any = await dispatch(
			RePublishObjective({
				teamCycleDetailId: selectedCycleDetails?.organisationCycleId,
			})
		);
		if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
			dispatch(refreshAdminDefaultOkrList(true));
			setPublishDisabled(false);
		} else {
		}
	};
	const handleCloseAlertModal = (e: React.ChangeEvent<HTMLInputElement>, type: number) => {
		e.preventDefault();

		if (type === 1) {
			handlePublishOkr();
			setModalOpen(false);
		} else {
			setModalOpen(false);
		}
	};
	const getPerformanceReviewList = async (requestPayload: any) => {
		const response: any = await dispatch(getAdminDefaultOkrList(requestPayload));
		if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
			setListingData(response.data.entity.defaultGoalObjectiveResponse);
			let hasRepublish = 0;
			let hasPublish = 0;
			response.data.entity.defaultGoalObjectiveResponse.forEach((okrAssignType: any) => {
				if (okrAssignType.status === 4) {
					hasRepublish = 4;
				} else if (okrAssignType.status === 3) {
					hasPublish = 3;
				}
			});
			setReublishButton(hasRepublish);
			setPublishButton(hasPublish);
			setAlertMessage(response.data.entity.unpublishedMessage);
			setTimeout(() => {
				setHighlightDefaultOkr(0);
			}, 5000);
			if (highlightDefaultOkr) {
				scrollTo(`default_okr_list_item_index_${highlightDefaultOkr}`);
			}
		} else {
			const { messageList } = response?.data || {};
			const keys = messageList ? Object.keys(messageList) : null;
			const messages = keys && keys?.length ? keys.map((item) => messageList[item]) : [];
			showApiMsg('error', messages || 'Error occurred while fetching default okr details');
		}
		setListLoading(false);
		setShowLoader(false);
	};
	const scrollTo = (elementId: string) => {
		setTimeout(function () {
			let element = document.getElementById(elementId);
			let topPos = element?.offsetTop;
			topPos = topPos ? topPos - 100 : 0;
			if (element) {
				element.scrollIntoView({ behavior: 'smooth' });
				window.scroll({ top: topPos, behavior: 'smooth' });
			}
		}, 800);
	};

	const handleExpandKeyResult = (e: any, okr: any) => {
		let list = Object.assign([], expandedKrList);
		const elementIndex = list.indexOf(okr.defaultGoalObjectiveId);
		if (elementIndex !== -1) {
			list.splice(elementIndex, 1);
		} else {
			list.push(okr.defaultGoalObjectiveId);
		}
		setExpandedKrList(list);
	};
	const handleExpandAll = () => {
		let defaultListing: any[] = [];
		listingData.forEach((okrKey: any) => {
			defaultListing.push(okrKey.defaultGoalObjectiveId);
		});
		setExpandedKrList(defaultListing);
	};
	const handleCollapseAll = () => {
		setExpandedKrList([]);
	};
	const deleteDefaultOkr = async (okrDetails: any) => {
		try {
			if (okrDetails?.defaultGoalObjectiveId) {
				setShowLoader(true);
				const isGoalObjective = true;
				const requestParams = `id=${okrDetails?.defaultGoalObjectiveId}&isGoalObjective=${isGoalObjective}&IsApplyInCurrentCycle=true`;
				const response: any = await dispatch(defaultOkrDelete(requestParams));
				if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
					defaultOkrAPICall(false);
				} else {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : null;
					const messages = keys && keys?.length ? keys.map((item) => messageList[item]) : [];
					showApiMsg('error', messages || 'Error occurred while fetching default okr details');
					setShowLoader(false);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleDeleteDefaultOkrClick = (event: any, okrDetails: any) => {
		try {
			// console.log('handleDeleteDefaultOkrClick ===> ', okrDetails);
			if (okrDetails?.status === Enums.ONE) {
				let msg = '';
				if (okrDetails?.defaultGoalKeyResponse?.length === Enums.ZERO) {
					msg = t('deleteKpiCategoryMessage');
				} else if (okrDetails?.defaultGoalKeyResponse?.length) {
					msg = t('deleteListingKpiCatMessage');
				}
				setModalPerformanceProps({
					open: true,
					message: msg,
					details: { okrDetails: okrDetails, deleteType: 'DefaultOKR' },
					event: event,
				});
			} else {
				setModalProps({
					open: true,
					message: '',
					details: {
						okrDetails: okrDetails,
						deleteType: 'DefaultOKR',
						headingText: t('deleteListingKpiCatMessage'),
						subHeading: '',
						matchString: Enums.DELETE_TEXT,
					},
				});
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handlePublishButton = () => {
		if (republishButton === 4) {
			handleRePublishOkr();
		} else {
			setModalOpen(true);
		}
	};

	const handlePerformanceCloseModal = async (e: any, type: any) => {
		e.preventDefault();
		if (type === 1) {
			const { details } = modalPerformanceProps || {};
			if (details && details?.deleteType === 'DefaultOKR') {
				const okrDetails = details?.okrDetails || null;
				if (okrDetails) {
					deleteDefaultOkr(okrDetails);
				}
			}

			setModalPerformanceProps({ open: false, message: '', details: '' });
		} else {
			setModalPerformanceProps({ open: false, message: '', details: '' });
		}
	};
	const handleConfirmationCloseModal = async (e: any, type: any) => {
		try {
			if (type === 1) {
				const { details } = modalProps || {};
				if (details && details?.deleteType === 'DefaultOKR') {
					const okrDetails = details?.okrDetails || null;
					if (okrDetails) {
						deleteDefaultOkr(okrDetails);
					}
				}
				setModalProps({ open: false, message: '', details: '' });
			} else {
				setModalProps({ open: false, message: '', details: '' });
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleExportMyOkrReport = async () => {
		try {
			const cycleId =
				selectedCycleDetails && selectedCycleDetails?.organisationCycleId
					? selectedCycleDetails?.organisationCycleId
					: 0;
			if (cycleId && userDetail?.employeeId) {
				// setListLoading(true);
				const isDesignation = false;
				const isJobLevel = false;
				const isUser = false;
				const employeeId = userDetail?.employeeId || 0;

				const requestParam = `?employeeId=${employeeId}&cycleId=${cycleId}&isDesignation=${isDesignation}&isJobLevel=${isJobLevel}&isUser=${isUser}`;
				const response: any = await dispatch(exportDefaultOkrReport(requestParam));
				if (response) {
					const defaultName = 'defaultOkrReport.xlsx';
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
					const matches = filenameRegex.exec(response.headers['content-disposition']);
					link.setAttribute('download', matches && matches.length > 0 ? matches[1] : defaultName);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				}
				// setListLoading(false);
			}
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<>
			{((!listLoading && listingData.length > 0) || appliedFilter) && (
				<Box className='default-okr-list-head'>
					<Box className='default-okr-list-head-left'>
						<Box className='expand-all'>
							{expandedKrList.length === listingData.length ? (
								<OKRButton
									className='expand-all-inner collapse-active'
									title={
										<Typography variant='body2' className='expand-txt'>
											{t('collapseAllLabel')}
										</Typography>
									}
									text={<RightArrowIcon />}
									handleClick={(e) => handleCollapseAll()}
								/>
							) : (
								<OKRButton
									className='expand-all-inner'
									title={
										<Typography variant='body2' className='expand-txt'>
											{t('expendAllLabel')}
										</Typography>
									}
									text={<RightArrowIcon />}
									handleClick={(e) => handleExpandAll()}
								/>
							)}
						</Box>
						<Typography className='sort-obj-title' variant='h2'>
							{t('keyPerformanceIndicators')}
						</Typography>
						{alertMessage && (
							<Box className='default-okrs-info-mssg'>
								<AlertInfoIcon />
								<Typography variant='body2'>{alertMessage}</Typography>
							</Box>
						)}
					</Box>
					<Box className='default-okr-list-head-right'>
						{appliedFilter && (
							<OKRButton
								className='btn-link'
								text={t('clearAll')}
								handleClick={() => {
									setFinalFilterCondition({ ...defaultSearchFilter });
									setAppliedFilter(false);
								}}
							/>
						)}
						<DefaultKpiFilter
							categories={categories}
							appliedFilter={appliedFilter}
							setAppliedFilter={setAppliedFilter}
							setFinalFilterCondition={setFinalFilterCondition}
							finalFilterCondition={finalFilterCondition}
							defaultSearchFilter={defaultSearchFilter}
						/>
					</Box>
				</Box>
			)}

			{listLoading ? (
				<Box className='loading-center'>
					<Typography>{t('loading')}</Typography>
				</Box>
			) : listingData.length === 0 ? (
				selectedCycleDetails?.cycleStatus !== 1 ? (
					<Box className='no-records-area no-kpis-area'>
						{appliedFilter ? (
							<Box className='no-record-message'>
								<Typography variant='h2' component='h2'>
									{t('noKpisFound')}
								</Typography>
								<img width='440' alt={t('globalSearchNoRecord')} src={noRecordFound} />
							</Box>
						) : (
							<Box className='no-record-message'>
								<Typography variant='h2' component='h2'>
									{t('createKpis')}
								</Typography>
								<Box className='get-started-card'>
									<AnimatedIcon
										className='add-user-img'
										width='157'
										type='image/svg+xml'
										alt='No user'
										imagePath={AddUserImg}
									/>

									<Box>
										<Box className='get-started-card-content'>
											<Typography>{t('createDefaultKpisCard')}</Typography>
										</Box>
										<Box className='get-started-card-link'>
											<Link onClick={handleClickDefaultOkr}>
												<AddIconBlue />
												{t('letsCreatetxt')}
											</Link>
											{/* <Link
											onClick={() => {
												dispatch(openAdminCopyOkr(true));
											}}
										>
											<CopyOkrsIcon />
											{t('copyOKRs')}
										</Link> */}
										</Box>
									</Box>
								</Box>
							</Box>
						)}
					</Box>
				) : (
					<Box className='no-records-area'>
						<Box className='no-record-message'>
							<Typography variant='h2' component='h2'>
								{t('defaultNoRecord')}
							</Typography>
							<AnimatedIcon className='' width='516' type='image/svg+xml' alt='No user' imagePath={DefaultOkrImg} />
						</Box>
					</Box>
				)
			) : (
				listingData.map((objData: any) => (
					<Box
						className={`default-okr-listing ${
							highlightDefaultOkr === objData?.defaultGoalObjectiveId ? 'highlight-default-row' : ''
						}`}
						id={`default_okr_list_item_index_${objData?.defaultGoalObjectiveId}`}
					>
						<Box className='default-okr-list-panel'>
							<Box className='default-okr-list-panel-inner'>
								<Box className='default-obj-list-panel'>
									<List disablePadding>
										<ListItem className='default-okr-col1'>
											<Box className='default-okr-name'>
												<Typography>{objData.name}</Typography>
											</Box>
											<Box className='default-okr-actions'>
												<OKRButton
													className={`btn-blue-chip ${
														expandedKrList.indexOf(objData.defaultGoalObjectiveId) !== -1 ? 'expand' : 'collapse'
													}`}
													icon={<RightArrowIcon />}
													text={objData.defaultGoalKeyResponse.length + ' KPI'}
													id={`kr-toggle-btn`}
													handleClick={(e) => handleExpandKeyResult(e, objData)}
												/>
												{selectedCycleDetails?.cycleStatus !== 1 && (
													<Box className='default-okr-field-actions'>
														<OKRButton
															className='edit-btn'
															id='obj-edit-btn'
															icon={<EditIcon />}
															title={t('editLabel')}
															handleClick={(e: any) => handleEditDefaultOkrClick(e, objData)}
														/>
														{/* <OKRButton
															className='delete-btn'
															id='obj-delete-btn'
															icon={<DeleteIcon />}
															title={t('delete')}
															handleClick={(e: any) => handleDeleteDefaultOkrClick(e, objData)}
														/> */}
													</Box>
												)}
											</Box>
										</ListItem>
										<ListItem className='default-okr-col2'>
											<OrgKpisAssignChip
												defaultOkrFormDetails={{
													assignIds: objData.defaultGoalObjectiveAssignDetails,
													assignType: objData.assignType,
												}}
												hideLabelButton={true}
											/>
										</ListItem>
									</List>
								</Box>
								<Collapse
									className='default-kr-list-panel default-kpi-list-panel'
									in={expandedKrList.indexOf(objData.defaultGoalObjectiveId) !== -1}
									timeout='auto'
									unmountOnExit
								>
									{objData.defaultGoalKeyResponse.map((keyData: any, keyIndex: number) => (
										<Box className='default-kr-list-inner'>
											<Box className='default-kr-list-inner-left'>
												<Box className='default-kr-name'>
													<Typography>{keyData.name}</Typography>
												</Box>
												<Box className='default-okr-actions'>
													<Box className='default-okr-status-info'>
														{keyData.status === 2 && <Chip className='published-chip' label={keyData.statusName} />}
														{keyData.status === 1 && (
															<Chip className='published-updated-chip' label={keyData.statusName} />
														)}
														{keyData.status === 3 && <Chip className='unpublished-chip' label={keyData.statusName} />}
														{keyData.status === 4 && (
															<Chip className='published-updated-chip' label={keyData.statusName} />
														)}
													</Box>
													{/* {keyData?.publishedOn ? (
														<Box className='set-timeline-area'>
															<Box className='timeline-field'>
																<Box className='calendar-btn'>
																	<OKRButton
																		title={t('publishedOn')}
																		text={keyData?.publishedOn ? `${getMonthDateYear(keyData?.publishedOn)}` : ''}
																		icon={<CalendarIcon />}
																		disabled={true}
																	/>
																</Box>
															</Box>
														</Box>
													) : (
														<></>
													)} */}
												</Box>
											</Box>
											<Box className='default-kr-list-inner-right'>
												<OrgKpisAssignChip
													defaultOkrFormDetails={{
														assignIds: keyData.defaultGoalKeyAssignDetails,
														assignType: keyData.assignType,
													}}
													krItem={keyData}
													keyIndex={keyIndex}
													hideLabelButton={true}
												/>
											</Box>
										</Box>
									))}
								</Collapse>
							</Box>
						</Box>
					</Box>
				))
			)}
			{modalProps && modalProps.open && (
				<DialogComponent
					module='confirmation'
					modalOpen={modalProps.open}
					handleCloseModal={(e: any) => handleConfirmationCloseModal(e, 2)}
					matchString={modalProps?.details?.matchString || Enums.DELETE_TEXT}
					handleConfirmClick={(e: any) => handleConfirmationCloseModal(e, 1)}
					headingText={modalProps?.details?.headingText || ''}
					subHeading={modalProps?.details?.subHeading || ''}
				/>
			)}
			{modalOpen && (
				<DialogComponent
					module='information'
					message={t('publishText')}
					handleCloseModal={handleCloseAlertModal}
					modalOpen={modalOpen}
				/>
			)}
			{modalPerformanceProps && modalPerformanceProps.open && (
				<AlertDialog
					module='PerformanceReviewList'
					isCancel={false}
					message={modalPerformanceProps?.message || ''}
					handleCloseModal={handlePerformanceCloseModal}
					modalOpen={modalPerformanceProps.open}
				/>
			)}
		</>
	);
};
